export type SeatNoun = 'seat' | 'assistant seat'

const floorHintCopy: Record<SeatNoun, (occupied: number) => string> = {
  seat: (occupied) =>
    `Number of seats can't be fewer than ${occupied} - the number of active users on this account. To use fewer seats, deactivate some users.`,
  'assistant seat': (occupied) =>
    `Number of assistant seats can't be fewer than ${occupied} - the number of users with an assistant on this account. To use fewer assistant seats, remove the assistant from some users.`,
}

export const seatFloorHint = (entered: number | null, current: number | undefined, occupied: number | undefined, noun: SeatNoun): string | null => {
  if (entered === null || current === undefined || occupied === undefined) {
    return null
  }
  if (entered >= current || entered >= occupied) {
    return null
  }
  return floorHintCopy[noun](occupied)
}
